import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=39c8d874&scoped=true"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"
import style0 from "./Send.vue?vue&type=style&index=0&id=39c8d874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c8d874",
  null
  
)

export default component.exports